export default {
  cookiebotLoaded: false,
  safeCookiebotMethod: null,
  cookiebotFailed: false
};